import React, {useState, useEffect} from 'react';
import {Navigate } from 'react-router-dom';
import {onAuthStateChanged} from 'firebase/auth';
import {auth} from './Firebase';

// localStorage.getItem("name") used to be read synchronously on first
// render, but Firebase only confirms auth state asynchronously (checking a
// persisted session, or finishing a sign-in redirect) -- so every fresh
// page load of a protected route bounced to /login first regardless of
// whether the user was actually signed in. Waiting on onAuthStateChanged
// itself removes that race entirely.
function PrivateRoute({children}) {
    const [authState, setAuthState] = useState("loading"); // "loading" | "in" | "out"

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            setAuthState(user ? "in" : "out");
        });
        return unsubscribe;
    }, []);

    if (authState === "loading") {
        return (
            <div className="page-loading">
                <div className="spinner"></div>
            </div>
        );
    }

    return authState === "in" ? children : <Navigate to={"/login"} />;
}

export default PrivateRoute
